// extracted by mini-css-extract-plugin
module.exports = {"content-panel":"styles_content-panel__1cXTD","intro-paragraph":"styles_intro-paragraph__1TPAL"};